<template>
  <Row>
    <Col span="24">
      <div style="display: flex; width: 102%; margin-bottom: 20px">
        <transition name="fade">
          <div class="newss">企业新闻</div>
        </transition>
      </div>
    </Col>
    <Col span="24">
      <div class="news_Col_div">
        <ul>
          <li
            v-for="(item, index) in NewsProfile"
            :key="index"
            @click="getLocal(item.name)"
          >
            <div class="news_ul_div">
              <div class="news_ul_div_div01">
                <img :src="item.img" alt="暂无照片" />
              </div>
              <div class="news_ul_div_div02">
                <p>{{ item.title }}</p>
                <span class="news_ul_div_div02_sp">
                  时间：{{ item.time }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                <br />
                <div class="news_ul_div_div02_sp2">
                  {{ item.content }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </Col>
  </Row>
</template>

<script>
export default {
  name: "NewsProfile",
  data() {
    return {
      NewsProfile: [
        {
          img: "../../../static/img/News/news07.jpg",
          title: "热烈欢迎陕西省宝鸡市港务区领导莅临南秀科技参观指导！",
          time: "2022-07-22",
          name: "NewsSeven",
          content:
            "7月22日下午，陕西省宝鸡市港务区调研团队莅临智慧岛大厦及南秀科技参观指导，领导们在四楼听取了创意岛孵化器运营情况。",
        },
        {
          img: "../../../static/img/News/09.jpg",
          title: "热烈欢迎内蒙古观摩团莅临南秀科技参观指导！",
          time: "2022-07-10",
          name: "NewsNine",
          content:
            "7月9日上午，为加快推进智慧岛建设实施意见，高标准推进智慧岛建设，不断提升科技创新能力，内蒙古观摩团到智慧岛大厦",
        },
        {
          img: "../../../static/img/News/news06.jpg",
          title:
            "热烈欢迎河南省政协副主席高体建等一众领导莅临智慧岛及南秀科技参观指导！",
          time: "2022-07-07",
          name: "NewsSix",
          content:
            "7月6日，为打造一流创新平台，建设国家创新高地，河南省政协副主席高体建，省政协常委、教科卫体委员会主任胡广坤 ，省政协常委、教科卫体委员会副主任修振环，省政协委员、省科学技术厅党组书记...",
        },
        {
          img: "../../../static/img/News/08.jpg",
          title:
            "热烈欢迎南阳市、驻马店市调研团队莅临智慧岛及南秀科技参观指导！",
          time: "2022-07-01",
          name: "NewsEight",
          content:
            "为贯彻落实智慧岛建设推进会会议精神，加快推动南阳市和驻马店市智慧岛建设工作，打造双创实际版，7月1日上午，南阳高新区党工委副书记、管委会主任党俊伟和驻马店市发展改革委副主任...",
        },
        {
          img: "../../../static/img/News/news01.jpg",
          title: "11月23日-24日,2020年中建科技...",
          time: "2020-12-02",
          // PageView: "151",
          name: "NewsOne",
          content:
            "在本次论坛大会上,中建五局河南公司万东波提出人机智联数字时代开启,施工现场应紧跟时代脉搏,积极拓展数据采集新路径。" +
            "中建五局与河南南秀建筑科技有限公司基于此目的联合研发的数字化实测实量管理系统已研发成功...",
        },
        {
          img: "../../../static/img/News/news02.jpg",
          title: "南秀科技虚拟质量样板荣获二等奖...",
          time: "2020-12-01",
          PageView: "143",
          name: "NewsTwo",
          content:
            "11月23日-24日，2020年中建科技月中建五局分会场暨中建五局第三届技术论坛在重庆成功举办。" +
            "中国工程院院士、著名岩土工程专家郑颖人，中国工程院院士、著名结构工程专家周绪红...",
        },
        {
          img: "../../../static/img/News/news03.jpg",
          title: "南秀科技开启建筑施工数据采集数字化...",
          time: "2020-11-24",
          PageView: "163",
          name: "NewsThree",
          content:
            "实测实量管理系统视频展示在建筑领域施工过程中，为保障工程施工质量，需要按照施工规范进行现场准确测量从而产生大量测量数据，" +
            "但是由于目前建筑施工过程中主要采用传统测量手段...",
        },
        {
          img: "../../../static/img/News/news04.jpg",
          title: "建筑业协会各位领导参观指导南秀科技产品...",
          time: "2020-10-24",
          PageView: "122",
          name: "NewsFour",
          content:
            "体验者戴上VR眼镜后，仿佛身临其境，整个工地逼真地展示在眼前，似乎触手可及。让体验者有更加逼真的感受，" +
            "可以直接体验高空坠落、洞口坠落、灭火器演示等体验效果。新兴VR科技体验激发了工人参加安全...",
        },
        {
          img: "../../../static/img/News/news05.jpg",
          title: "南秀科技携众多科技产品助力国基建设观摩会...",
          time: "2020-09-26",
          PageView: "172",
          name: "NewsFive",
          content:
            "VR/AR软件定制开发服务、VR安全体验馆（房建、隧道、桥梁、党建、校园安全）、标志标识识别系统、实测实量系统-数字蓝牙回弹仪、数字蓝牙靠尺、" +
            "三维立体展示平台、AR工法质量样板、工程项目智能机器人、互动台-电子沙盘、虚拟灭火体验系统、安全体验场馆搭建、工法质量样板服务。...",
        },
      ],
    };
  },
  methods: {
    getLocal(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style scoped>
.news_Col_div {
}

.news_Col_div ul li {
  width: 98%;
  height: 176px;
  background: white;
  margin-bottom: 20px;
  border-bottom: 1px solid #eaeaea;
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 10px;
}

.news_Col_div ul li:hover {
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
}

.news_ul_div {
  display: flex;
  padding-top: 20px;
}

.news_ul_div_div01 img {
  width: 170px;
  height: 130px;
  margin-left: 30px;
  border-radius: 5px;
}

.news_ul_div_div02 {
  width: 673px;
  height: 130px;
  background: white;
  margin: 17px 0 0 91px;
}

.news_ul_div_div02 p {
  font-size: 17px;
}

.news_ul_div_div02_sp {
  font-size: 12px;
  color: #888;
  line-height: 26px;
}

.news_ul_div_div02_sp2 {
  height: 40px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.newss {
  width: 100%;
  text-align: center;
  color: #1f1f1f;
  font-size: 40px;
  padding-top: 25px;
}

.fade-leave {
  opacity: 1;
}
.fade-leave-active {
  transition: all 1s;
}
.fade-leave-to {
  opcaity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/News/NewsProfile.vue